export const resolveSuggestedQuestions = (
  inlineQuestions: string[] | undefined,
  tenantQuestions: string[] | undefined,
): string[] => {
  return inlineQuestions ?? tenantQuestions ?? [];
};
